import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { Skeleton } from '../common/skeleton/Skeleton';
import './HelpCenter.scss';
const HelpCenterSkeleton = () => {
  return (
    <div className="help-center">
      <Row className="health-card">
        {[1, 2].map((item, index) => (
          <Col sm={2} md={12} lg={3} xs={12} key={index}>
            <Card className="help-card">
              <div className="help-card-content">
                <Skeleton
                  count={1}
                  width={80}
                  height={80}
                  circle={true}
                  containerClassName={'help-svg-skeleton'}
                />

                <div className="help-card-name">
                  <Skeleton count={1} width={100} />
                </div>
                <p>
                  <span>
                    <Skeleton count={1} width={230} height={100} />
                  </span>
                </p>
                <div className="pl-3">
                  <a className="download_document">
                    <Skeleton count={1} width={150} height={20} />
                  </a>
                </div>
              </div>
            </Card>
          </Col>
        ))}
        <Col sm={8} md={12} lg={6} xs={12}></Col>
      </Row>
    </div>
  );
};
export default HelpCenterSkeleton;
